import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useDeleteInjection = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({
      injectionId,
      consultationId,
    }: {
      injectionId: string;
      consultationId: string;
    }) => {
      return api.delete(`injections/${injectionId}`);
    },
    onSuccess: (res, variables) => {
      // console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "delete-injection-success",
      });
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.injectionsWithFilters(
          variables.consultationId
        ),
      });
    },

    onError: (res, variables) => {
      console.error("[From Delete Injection]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.injectionsWithFilters(
          variables.consultationId
        ),
      });

      handleErrors(res, "mutation");
    },
  });
};
